import MaterialTable from '@material-table/core';
import { useStoreUtils } from 'hooks/useStoreUtils';
import React, { useEffect, useState } from 'react';
import HeaderTable from './HeaderTable';
import './MyTable.scss'

const MyTable = ({
    title = '',
    columns: columnsFromParams = [],
    data = [],
    options = {},
    filters = null,
    onRowClick = null
}) => {
    const [rows, setRows] = useState(data)
	const [columns, setColumns] = useState(columnsFromParams || [])
    const { state: { tableLoading } } = useStoreUtils()
    useEffect(() => {
        setRows(data)
    }, [data])

    useEffect(() => {
        setColumns(columnsFromParams || [])
    }, [columnsFromParams])

    return <div
        className='root'
    >
        <HeaderTable filters={filters} rows={data} setRows={setRows} />
        <MaterialTable
            {...(onRowClick ? { onRowClick } : {})}
            title={title}
            columns={columns}
            data={rows.map(d => ({...d}))}
            options={{
                ...options,
                search: false,
                paging: false
            }}
            isLoading={tableLoading}
        />
    </div>
};

export default MyTable;